import { useQuery } from "@tanstack/react-query";
import { fetchOrders } from "./api/orders";

export const useGetOrders = (page, token, per_page) => {
  return useQuery({
    queryKey: ["orders", page, token, per_page],
    queryFn: () => fetchOrders(page, token, per_page),
    enabled: !!token,
  });
};
